module.exports = __webpack_public_path__ + "img/logo.e987db30.svg";